<template>
  <NodeEditorial v-if="node?.__typename === 'NodeEditorial'" v-bind="node" />
  <NodeAccomodation
    v-else-if="node?.__typename === 'NodeAccomodation'"
    v-bind="node"
  />
  <NodePlace v-else-if="node?.__typename === 'NodePlace'" v-bind="node" />
  <NodeTour v-else-if="node?.__typename === 'NodeTour'" v-bind="node" />
  <div v-else />
</template>

<script lang="ts" setup>
// Yes, there needs to be an empty div in the template.

defineOptions({
  name: 'PageSlug',
})

definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
  languageMapping: {
    fr: '/:slug(.*)*',
    en: '/:slug(.*)*',
    it: '/:slug(.*)*',
    es: '/:slug(.*)*',
  },
})

const { entity: node, metatags } = await useDrupalRouteQuery('all')

/* eslint-disable  @typescript-eslint/no-explicit-any */
useLogo().setLogoThemeFragment(node as any)
// The generic type V for the fragment can't be made compatible with these
// argument type, which is why we have to cast is as any here (which is fine).
/* eslint-disable  @typescript-eslint/no-explicit-any */
usePageTracking(node as any, metatags)
/* eslint-disable  @typescript-eslint/no-explicit-any */
setActiveChannel(node as any)

await renderPageDependencies()
</script>
